import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { MenuptionsConfigI } from 'src/app/core/interfaces/table.interface';
@Component({
  selector: 'app-options-popover',
  templateUrl: './options-popover.component.html',
  styleUrls: ['./options-popover.component.scss'],
})
export class OptionsPopoverComponent implements OnChanges {
  @Input() options: MenuptionsConfigI[] = [];
  constructor(private popoverCtrl: PopoverController) {}

  ngOnChanges(changes: SimpleChanges): void {}

  selectItem(category?: string) {
    this.popoverCtrl.dismiss(category);
  }

  dismissPopover() {
    this.popoverCtrl.dismiss();
  }
}
